<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Solicitações de Acesso – Visualizar Parecer
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-subheader inset class="ml-0 mt-3">
              <strong>Dados Pessoais</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="9">
                <v-text-field
                  id="nome"
                  v-model="content.nome"
                  label="Nome"
                  outlined
                  disabled
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  id="cpf"
                  v-model="content.cpf"
                  label="CPF"
                  v-mask="'###.###.###-##'"
                  outlined
                  dense
                  hide-details="auto"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="8">
                <v-text-field
                  id="email"
                  label="E-mail"
                  v-model="content.email"
                  dense
                  outlined
                  hide-details="auto"
                  disabled
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  id="telefone"
                  label="Telefone para contato"
                  v-model="content.telefone"
                  v-mask="'(##) #####-####'"
                  dense
                  outlined
                  hide-details="auto"
                  disabled
                />
              </v-col>
              <v-col :cols="content.possuiNomeSocial ? '6' : '12'">
                <span class="mr-4">Possui nome social?</span>
                <v-radio-group
                  v-model="content.possuiNomeSocial"
                  class="ml-4"
                  row
                  dense disabled>
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6" v-if="content.possuiNomeSocial">
                <v-text-field
                  v-model="content.nomeSocial"
                  label="Nome Social"
                  outlined
                  dense
                  maxlength="100"
                  counter="100"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-subheader inset class="ml-0 mt-5">
              <strong>Formação Profissional</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-text-field
                  id="grauEscolaridade"
                  label="Grau de Escolaridade"
                  v-model="content.escolaridade"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="localLotacao"
                  label="Local de Lotação"
                  v-model="content.lotacao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="6">
                <v-text-field
                  id="funcaoPrograma"
                  label="Função no Programa"
                  v-model="content.funcao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="municipio"
                  label="Município"
                  v-model="content.municipio"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col :cols="content.possuiLotacaoDois ? '6' : '12'">
                <span class="mr-4">Possui outro local de lotação?</span>
                <v-radio-group
                  v-model="content.possuiLotacaoDois"
                  row
                  dense
                  disabled
                  class="ml-4">
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6"></v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-2" v-if="content.possuiLotacaoDois">
              <v-col cols="6">
                <v-text-field
                  :value="content.municipioDois"
                  label="Município"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.lotacaoDois"
                  label="Local de Lotação"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-subheader inset class="ml-0 mt-5">
              <strong>Parecer</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="4">
                <v-text-field
                  label="Situação*"
                  v-model="content.situacao.descricao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col  cols="8">
                <v-text-field
                 v-if="content?.perfil?.descricao"
                  id="perfilAcesso"
                  label="Perfil de acesso*"
                  v-model="content.perfil.descricao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-textarea
                  id="justificativa"
                  label="Justificativa*"
                  v-model="content.justificativa"
                  outlined
                  dense
                  hide-details="auto"
                  disabled
                />
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
            <v-btn color="primary" @click="$emit('onClose')">
              <v-icon>mdi-close</v-icon>
              Fechar
            </v-btn>
          </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { SolicitacaoAcesso } from '~/commons/classes/solicitacao-acesso';

export default {
  props: new DialogProps(SolicitacaoAcesso),
  data: () => ({
    form: {
      lists: {
        listPerfilAcesso: [],
        listSituacoes: [],
      },
    },
  }),
};
</script>
